import React from "react";
import { useParams } from "react-router";
import useFiringActions from "../hooks/useFiringActions";
import FiringForm from "./FiringForm";

const FiringCreatePage = () => {
  const { id, order } = useParams();
  const { createFiring } = useFiringActions();

  const handleSubmit = (formValues: any) => {
    const values = {
      project_id: id,
      order: order,
      ...formValues,
    };
    createFiring(values);
  };

  return (
    <div>
      <FiringForm
        onSubmit={handleSubmit}
        initialValues={{
          notes: "",
          name: "",
          date: Date.now(),
        }}
      />
    </div>
  );
};

export default FiringCreatePage;
